/**
 * A selectable item card shown in the chest loot modal.
 * Displays icon, name, rarity, stat mods, and legendary ability badge.
 *
 * Props:
 *   item     — item object
 *   color    — resolved rarity color string
 *   onChoose — () → void
 */
export function LootCard({ item, color, onChoose }) {
  return (
    <button
      className="chest-item-card"
      style={{ '--item-color': color }}
      onClick={onChoose}
    >
      <span className="chest-item-icon">{item.icon}</span>
      <span className="chest-item-name" style={{ color }}>{item.name}</span>
      <span className="chest-item-rarity">{item.rarity}</span>

      {item.statMods && Object.keys(item.statMods).length > 0 && (
        <div className="chest-item-stats">
          {Object.entries(item.statMods).map(([k, v]) => (
            <div key={k} className="chest-item-stat">
              {k}: {typeof v === 'number' && v > 0 ? '+' : ''}
              {typeof v === 'number' ? (Number.isInteger(v) ? v : v.toFixed(2)) : v}
            </div>
          ))}
        </div>
      )}

      {item.abilityId && (
        <div className="chest-item-ability">✨ Legendary ability</div>
      )}
    </button>
  );
}
